import { Commodity } from '@/hooks'

export const getUnitNameByUnitId = (
    unitId: number,
    commodities: Commodity[] | undefined
): string => {
    if (!commodities) return ''
    const unit = commodities
        .flatMap((c) => c.unitsOfMeasure)
        .find((u) => u.unitOfMeasureId === unitId)
    return unit?.unit ?? ''
}
